/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneRequest
 */
export interface PhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof PhoneRequest
     */
    number: string;
}

/**
 * Check if a given object implements the PhoneRequest interface.
 */
export function instanceOfPhoneRequest(value: object): value is PhoneRequest {
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function PhoneRequestFromJSON(json: any): PhoneRequest {
    return PhoneRequestFromJSONTyped(json, false);
}

export function PhoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
    };
}

export function PhoneRequestToJSON(value?: PhoneRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'number': value['number'],
    };
}

